/**
 * ConciergeActions Component
 *
 * Renders a row of contextual action buttons delivered by the sidecar.
 * Once any button is clicked, all buttons are disabled to prevent double-action.
 * Supports primary / secondary / danger styles.
 */

import React, { useState } from 'react';
import { Box, Button } from '@mui/material';

export interface ConciergeActionItem {
  id: string;
  label: string;
  style: 'primary' | 'secondary' | 'danger';
}

export interface ConciergeActionsProps {
  actions: ConciergeActionItem[];
  onAction: (id: string) => void;
}

export const ConciergeActions: React.FC<ConciergeActionsProps> = ({
  actions,
  onAction,
}) => {
  const [selected, setSelected] = useState<string | null>(null);

  if (actions.length === 0) return null;

  const handleClick = (id: string) => {
    if (selected !== null) return;
    setSelected(id);
    onAction(id);
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
      {actions.map((action) => (
        <Button
          key={action.id}
          variant={action.style === 'primary' ? 'contained' : 'outlined'}
          color={action.style === 'danger' ? 'error' : 'primary'}
          disabled={selected !== null}
          onClick={() => handleClick(action.id)}
          size="small"
        >
          {action.label}
        </Button>
      ))}
    </Box>
  );
};

export default ConciergeActions;
